import AppContext from 'App.context';
import PrivateRoute from 'components/PrivateRoute/PrivateRoute';
import { AssociadoRoutePath, AssembleiaAssociadoRoutePath } from 'library/Routes';
import React, { useContext } from 'react';
import { makeAuthenticator } from 'react-oidc';
import { Switch } from 'react-router-dom';
import Assembleia from './AssembleiaAssociado';
import Home from './Home';
// import ProximosEventos from './ProximosEventos';

const AssociadoApp = () => {
  return (
    <Switch>
      <PrivateRoute path={AssociadoRoutePath} exact>
        <Home />
      </PrivateRoute>
      <PrivateRoute path={AssembleiaAssociadoRoutePath} exact>
        <Assembleia />
      </PrivateRoute>
      {/* <PrivateRoute path="/assembleiadigital/associado/proximoseventos" exact>
        <ProximosEventos />
      </PrivateRoute> */}
    </Switch>
  );
};

export default function AssociadoArea() {
  const { associadoManager } = useContext(AppContext);

  if (associadoManager) {
    const AuthArea = makeAuthenticator({ userManager: associadoManager })(AssociadoApp);
    return <AuthArea />;
  }

  return null;
}
